import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=d68953ea&scoped=true"
import script from "./drafts.vue?vue&type=script&lang=js"
export * from "./drafts.vue?vue&type=script&lang=js"
import style0 from "./drafts.vue?vue&type=style&index=0&id=d68953ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68953ea",
  null
  
)

export default component.exports